import { OperationStatusType } from 'api/types/entity/operation/operationStatusType';
import { ChipVariant } from 'libs/ui';
import { ChipOperationStatus } from 'modules/operation/common/components';
import { OperationsListItem } from 'modules/operation/operations/types';

export const renderStatus = (item: OperationsListItem) => {
  let variant: ChipVariant | null = null;

  switch (item.status) {
    case OperationStatusType.Concluded:
      variant = 'green';
      break;
    case OperationStatusType.Cancelled:
      variant = 'red';
      break;
    default:
      variant = null;
      break;
  }

  if (variant === null) {
    return null;
  }

  return (
    <ChipOperationStatus size="m" status={item.status} uppercase={false} />
  );
};
